import { create } from "zustand";

import { SearchQueryRequestedPage } from "types/generated";
import { UsePaginationFetchMoreProps } from "components/Table/Pagination/types";

type IntentProjectsStore = {
  cursor: string | null;
  requestedPage: SearchQueryRequestedPage;
  onFetchItems: (props: UsePaginationFetchMoreProps) => void;
  resetPagination: () => void;
};

const useIntentProjectsStore = create<IntentProjectsStore>((set) => ({
  cursor: null,
  requestedPage: SearchQueryRequestedPage.First,
  onFetchItems: ({ cursor, requestedPage }) => set({ cursor, requestedPage }),
  resetPagination: () => set({ cursor: null, requestedPage: SearchQueryRequestedPage.First }),
}));

export default useIntentProjectsStore;
